class AnnouncementSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.timer = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
    this.previousButton = this.querySelector('[name="previous"]');
    this.nextButton = this.querySelector('[name="next"]');
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 5000;

    if (this.slides.length < 2) {
      return;
    }

    this.slides.forEach((slide, index) => {
      slide.dataset.state = index === this.currentIndex ? 'active' : 'enter-next';
    });

    this.previousButton?.addEventListener('click', () => this.showPrevious());
    this.nextButton?.addEventListener('click', () => this.showNext());
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    if (window.Shopify && Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-announcement-slide]');
        const selectedIndex = this.slides.indexOf(selectedSlide);

        if (selectedIndex > -1) {
          this.showSlide(selectedIndex);
          this.stopAutoplay();
        }
      });
    }

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  showPrevious() {
    this.showSlide(this.currentIndex - 1, 'previous');
    this.restartAutoplay();
  }

  showNext() {
    this.showSlide(this.currentIndex + 1, 'next');
    this.restartAutoplay();
  }

  showSlide(index, direction = 'next') {
    const previousIndex = this.currentIndex;
    const nextIndex = (index + this.slides.length) % this.slides.length;

    if (previousIndex === nextIndex) {
      return;
    }

    const previousSlide = this.slides[previousIndex];
    const nextSlide = this.slides[nextIndex];

    this.currentIndex = nextIndex;

    nextSlide.dataset.state = `enter-${direction}`;
    nextSlide.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        previousSlide.dataset.state = `exit-${direction}`;
        nextSlide.dataset.state = 'active';
      });
    });

    this.slides.forEach((slide, slideIndex) => {
      if (slideIndex !== previousIndex && slideIndex !== nextIndex) {
        slide.dataset.state = direction === 'next' ? 'enter-next' : 'enter-previous';
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    previousSlide.addEventListener('transitionend', () => {
      previousSlide.setAttribute('aria-hidden', 'true');
    }, { once: true });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = window.setInterval(() => {
      this.showSlide(this.currentIndex + 1, 'next');
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.startAutoplay();
  }
}

if (!customElements.get('announcement-slider')) {
  customElements.define('announcement-slider', AnnouncementSlider);
}
